import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_LABOR_RATES = `${ACCOUNT_SERVICE}/labor-rates`;

export const laborRates = {
  getAll: async ({
    filters,
    sort,
    params,
    signal,
    top,
    skip,
    toastMessageConfig,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_LABOR_RATES}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      params,
      signal,
      top,
      skip,
      toastMessageConfig,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_LABOR_RATES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_LABOR_RATES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { ...data, modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_LABOR_RATES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
